// Calculated status of a fabrication order (`statusProgress`, text enum from Sun: UNKNOWN | IN_PROGRESS |
// ACTIVE_EXECUTION | FINISHED | CANCELED | PARTIALLY_FINISHED) -> i18n key. ONE map for the table's "Status
// progress" column and the detail's General block (story 178, S73/S74, DP7), so both surfaces always read the
// same word for the same value. `PARTIALLY_FINISHED` (story 178, RN21) is the only value a manual close with
// incomplete parts produces; it is computed by Sun and only RENDERED here — never derived from counters.
import { systemValueLabel } from '../../generic/systemValues/systemValueLabel'

// Story 204 (RN1.5): the codes whose text differs between screens keep their legacy key until the PO picks one
// (P1-bis); IN_PROGRESS, CANCELED and PARTIALLY_FINISHED are translated by their own code.
export const STATUS_PROGRESS_KEYS = Object.freeze({
  UNKNOWN: 'Unknown',
  ACTIVE_EXECUTION: 'Active execution',
  FINISHED: 'Finished'
})

export const PARTIALLY_FINISHED = 'PARTIALLY_FINISHED'

// A value outside the enum (a newer Sun) is shown as it comes rather than hidden; an absent value stays empty.
export const statusProgressLabel = (t_, statusProgress) =>
  systemValueLabel(t_, 'FabricationOrderStatusEnum', statusProgress || '', STATUS_PROGRESS_KEYS)
